@if (this.sortedRows().length > 0) {
  <div class="duct-subsection">
    <div class="duct-table">
      <div class="duct-table-header">
        <div class="duct-table-cell duct-table-cell-direction">
          <gc-button
            (click)="toggle()"
            [attr.aria-expanded]="isExpanded()"
            [variant]="'utility'"
            [icon]="isExpanded() ? 'chevronDown' : 'chevronRight'"
            [iconPosition]="'right'"
            [size]="'small'"
          >
            {{ titleKey() || '' | translate }}
          </gc-button>
        </div>

        @if (isExpanded()) {
          <div class="duct-table-cell duct-table-cell-header">
            <gc-text [variant]="'bodyBold'">
              {{ this.nameLabelKey() || '' | translate }}
            </gc-text>
          </div>

          <div class="duct-table-cell duct-table-cell-header"></div>

          <div
            class="duct-table-cell duct-table-cell-header duct-table-cell-right"
          >
            <gc-text [variant]="'bodyBold'">
              {{ fromToLabelKey() || '' | translate }}
            </gc-text>
          </div>
        }
      </div>

      @if (isExpanded()) {
        @for (duct of sortedRows(); track $index) {
          <div class="duct-table-row">
            <div class="duct-table-cell">
              <gc-text [variant]="'body'">
                {{ duct.name | ductDbName }}
              </gc-text>
            </div>
            <div class="duct-table-cell">
              <gc-text [variant]="'body'">
                {{ duct.ductName }}
              </gc-text>
            </div>

            <div
              class="duct-table-cell duct"
              [style.background-color]="duct.colorCode"
            ></div>

            <div class="duct-table-cell duct-table-cell-right">
              <gc-text [variant]="'body'">
                {{
                  (useFromPoint() ? duct.fromPointName : duct.toPointName)
                    | pointLabel
                }}
              </gc-text>
            </div>
          </div>
        }
      }
    </div>
  </div>
}
